<template>
    <base-page>
      <el-card style="margin: 5px 0px 5px 0px">
        <el-collapse accordion style="border: none">
          <el-collapse-item name="1" style="border: none">
            <template slot="title">
              <div slot="header" class="clearfix">
                <titlu-pagina
                  Titlu="Raport produse"
                  :AdaugaVisible="false"
                />
              </div>
            </template>
        <div class="filtre">
          <el-form>
            <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element">
                    <el-form-item label='Interval' size="mini">
                      <br>
                       <el-date-picker      
                           v-model="Filters.Data"
                           type="daterange"
                           range-separator="-"
                           start-placeholder="Data inceput"
                           end-placeholder="Data sfarsit"
                           :picker-options="datePickerOptions"
                           format="dd/MM/yyyy" value-format="yyyy-MM-dd" />
                    </el-form-item>
                 </el-col>
                 <el-col :md="24">
                    <el-button
                      type="primary"
                      native-type="submit"
                      @click="refresh_info()"
                      size="mini">
                      Aplica
                    </el-button>
                    <el-button type="danger" native-type="submit" @click="reset()" size="mini">
                      Reseteaza
                    </el-button>
                  </el-col>
            </el-row>
          </el-form>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
  
      <el-table :data="Results">
        <el-table-column prop="NumeProdus" label="Nume produs"></el-table-column>
        <el-table-column prop="Cantitate" label="Cantitate"></el-table-column>
        <el-table-column prop="TimpMontaj" label="Timp montaj"></el-table-column>
        <el-table-column prop="CostMontaj" label="Cost montaj"></el-table-column>
        <el-table-column label="Total cost montaj">
          <template slot-scope="scope">
            {{ scope.row.Cantitate * scope.row.CostMontaj  }}
          </template>
        </el-table-column>
        <el-table-column label="Total servicii">
          <template slot-scope="scope">
            {{ scope.row.Serviciu == 1 ? scope.row.Cantitate * scope.row.CostMontaj : 0 }}
          </template>
        </el-table-column>
      </el-table>
  
      <div style="display:flex;justify-content:space-between">
        <el-pagination
        @size-change="refresh_info"
        @current-change="refresh_info"
        :page-size.sync="PaginationInfo.PerPage"
        :current-page.sync="PaginationInfo.Page"
        :total="PaginationInfo.RowCount"
        layout="pager"
      />
      <p style="font-weight:bold;font-size:18px">Total cost montaj: {{totalCostMontaj}}</p>
      </div>
      
    </base-page>
  </template>
  
  
  
  <script>
  import settings from "@/backend/LocalSettings";
  import BasePage from "@/pages/Admin/BasePage";
  import TitluPagina from "@/widgets/TitluPagina";
  import moment from 'moment';
  
  export default {
    name: "raport_produse_mecanici",
    extends: BasePage,
    components: {
      "base-page": BasePage,
      "titlu-pagina": TitluPagina,
    },
    data() {
      return {
        datePickerOptions: settings.datePickerOptions,
        Results: [],
        base_url: "",
        Info: {
        },
        Filters: {
            
            Data: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD 23:59:59')],
            
        },
        OrderBy: {},
        PaginationInfo: {
          Page: 1,
          PerPage: 50,
          RowCount: 0,
          PageSizes: [10, 25, 50, 100, 200],
        },
        totalCostMontaj:'',
      };
    },
    methods: {
      async get_info() {
        this.refresh_info();
      },
  
      async refresh_info() {
        var response = await this.post("service/devize/index_raport_produse", {
          Filters: this.Filters,
          OrderBy: this.OrderBy,
          PaginationInfo: this.PaginationInfo,
        });
        this.Results = response.Results;
        this.totalCostMontaj = response.totalCostMontaj;
        this.PaginationInfo = response.PaginationInfo;
        
      },
      reset() {
        this.Filters = {
            Data:'',
        };
        this.refresh_info();
      },  
     
    },
    mounted() {
      this.base_url = settings.BASE_URL;
      this.get_info();
    },
  };
  </script>
  
  <style lang="less" scoped>
  .top50 {
    margin-top: 20px;
  }
  
  .filtre {
    .el-input-number {
      width: 100% !important;
    }
  }
  
  .input-element {
    margin-right: 2%;
    width: 23%;
  }
  
  @media only screen and (max-width: 600px) {
    .input-element {
      width: 80%;
    }
  
    .el-tooltip__popper {
      width: 90%;
    }
  }
  </style>
  